var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIfj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 702,
    height: 768,
    viewBox: "-1.77717603 -1.77717603 62.79355306 68.71934506",
    id: "svg3965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3967"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 32.67378,18.049984 C 32.67676,18.079164 32.68124,19.443724 33.38639,19.851494 L 33.38639,23.512854 L 25.56024,23.381574 L 25.66931,19.644794 C 26.59394,19.419524 26.2964,17.931964 26.31181,17.384444 L 26.31181,8.8507636 C 26.31181,8.8507636 26.35243,7.4032636 25.59936,6.8336836 L 25.59936,3.2025436 L 33.51304,3.2025436 L 33.54569,6.7174736 C 32.79909,6.9537936 32.65638,7.5968536 32.68389,7.5891636 L 32.67378,18.049984",
    id: "path2691",
    style: {
      fill: "#c13128",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 42.21623,11.169494 L 46.14944,11.176134 L 46.18873,15.302794 L 42.21623,15.249134 L 42.1786,18.613414 C 42.26994,19.275134 42.42691,19.518314 42.77038,19.704624 L 42.77038,23.578504 L 35.1438,23.578504 L 35.1438,19.597214 C 35.88228,19.489964 35.8294,18.666954 35.8294,18.666954 L 35.8294,8.4267236 C 35.82856,8.1634336 36.20403,6.9824536 35.02329,6.8213836 L 34.76819,3.1935536 L 49.75576,3.1935536 L 49.73156,10.149574 L 44.36368,10.203254 C 44.63205,8.0024436 44.09531,7.0897736 42.16269,7.6803036 L 42.21623,11.169494",
    id: "path2701",
    style: {
      fill: "#c13128",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51.98229,7.9975036 C 51.98229,7.9975036 51.98676,6.9020836 51.31693,6.7909536 L 51.31693,3.1705636 L 59.2392,3.1705636 L 59.2392,6.8279536 C 59.13046,7.0089936 58.28409,6.7909536 58.40741,8.1826936 L 58.40741,17.323944 C 58.4321,17.459534 59.58051,25.534994 49.77616,23.384724 L 49.72693,19.534064 C 49.72693,19.534064 52.35708,20.089694 51.98229,17.108454 L 51.98229,7.9975036",
    id: "path2703",
    style: {
      fill: "#c13128",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.45746,8.5123636 C 9.91435,9.0551336 12.01778,5.9508136 7.01853,6.0385436 C 3.57944,6.0989236 4.78608,8.5123636 4.78608,8.5123636 L 10.45746,8.5123636 z M 16.02296,8.4379036 C 16.64305,8.2575736 16.85721,7.8179036 16.85721,7.8179036 L 20.4967,7.8239036 L 20.47598,15.325784 L 16.95519,15.313644 C 16.95519,15.313644 16.06861,14.485484 15.19334,14.724894 L 5.23755,14.724894 C 5.23755,14.724894 4.36373,14.787054 3.91209,15.366884 L 0.34561,15.366884 L 0.34561,6.5575236 C 0.44209,1.9359136 1.3227,-0.43315645 9.37158,0.065423551 C 16.18921,0.48776355 14.77164,8.4492236 14.77164,8.4492236 L 16.02296,8.4379036",
    id: "path2705",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.84741,17.745644 C 14.87654,17.742834 16.24085,17.738354 16.64885,17.033204 L 20.31021,17.033204 L 20.1791,24.859344 L 16.4419,24.750274 C 16.21689,23.825484 14.72924,24.123024 14.18176,24.107784 L 5.64824,24.107784 C 5.64824,24.107784 4.20073,24.067004 3.63108,24.820064 L 0,24.820064 L 0,16.906554 L 3.51486,16.873904 C 3.75119,17.620334 4.39433,17.763054 4.38655,17.735534 L 14.84741,17.745644",
    id: "path2707",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.06036,33.284224 L 8.06701,29.351014 L 12.19359,29.312054 L 12.14016,33.284224 L 15.5043,33.321854 C 16.16605,33.230514 16.4092,33.073704 16.59548,32.730244 L 20.46951,32.730244 L 20.46951,40.356644 L 16.4882,40.356644 C 16.38071,39.618504 15.55773,39.671224 15.55773,39.671224 L 5.31768,39.671224 C 5.05431,39.672214 3.8734,39.296264 3.71219,40.477324 L 0.0845,40.732594 L 0.0845,25.744684 L 7.04038,25.769054 L 7.09413,31.136944 C 4.89324,30.868564 3.98058,31.405304 4.5711,33.337934 L 8.06036,33.284224",
    id: "path2709",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.17538,50.317654 C 11.17279,50.288474 11.16825,48.924084 10.46311,48.516304 L 10.46311,44.854944 L 18.28924,44.986064 L 18.18016,48.723174 C 17.25554,48.948114 17.55309,50.435834 17.53751,50.983184 L 17.53751,59.516804 C 17.53751,59.516804 17.49706,60.964244 18.25011,61.533794 L 18.25011,65.164994 L 10.33654,65.164994 L 10.30383,61.650004 C 11.05009,61.413624 11.19286,60.770624 11.16535,60.778424 L 11.17538,50.317654",
    id: "path2711",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.71429,57.104454 L 22.7809,57.097994 L 22.74195,52.971344 L 26.71429,53.024884 L 26.75175,49.660734 C 26.66041,48.999004 26.5036,48.755834 26.16014,48.569684 L 26.16014,44.695644 L 33.78654,44.695644 L 33.78654,48.676764 C 33.0484,48.784344 33.10111,49.607354 33.10111,49.607354 L 33.10111,59.847334 C 33.1021,60.110564 32.72633,61.291624 33.90738,61.452914 L 34.16249,65.080454 L 19.17458,65.080454 L 19.19911,58.124564 L 24.567,58.070854 C 24.29846,60.271854 24.83536,61.184374 26.76783,60.593924 L 26.71429,57.104454",
    id: "path2713",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.62896,60.175384 C 7.62896,60.175384 7.62443,61.270904 8.29429,61.381964 L 8.29429,65.002214 L 0.372,65.002214 L 0.372,61.345004 C 0.48078,61.163654 1.32708,61.381964 1.20373,59.990054 L 1.20373,50.848914 C 1.17911,50.713154 0.03075,42.637874 9.83504,44.788144 L 9.88425,48.638974 C 9.88425,48.638974 7.25406,48.083334 7.62896,51.064574 L 7.62896,60.175384",
    id: "path2715",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.11173,38.110074 C 44.08255,38.113054 42.71833,38.117524 42.31038,38.822684 L 38.64901,38.822684 L 38.78014,30.996534 L 42.51725,31.105604 C 42.74236,32.030234 44.2299,31.732684 44.77743,31.748104 L 53.31088,31.748104 C 53.31088,31.748104 54.75848,31.788714 55.32821,31.035654 L 58.95924,31.035654 L 58.95924,38.949324 L 55.4444,38.981984 C 55.2082,38.235384 54.56488,38.092664 54.57265,38.120184 L 44.11173,38.110074",
    id: "path2717",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.63961,57.351444 L 50.63315,61.284824 L 46.50665,61.323944 L 46.56004,57.351444 L 43.19587,57.313984 C 42.53416,57.405324 42.29099,57.561974 42.10484,57.905424 L 38.2308,57.905424 L 38.2308,50.279024 L 42.21191,50.279024 C 42.3195,51.017164 43.14251,50.964454 43.14251,50.964454 L 53.38248,50.964454 C 53.64571,50.963464 54.82678,51.339414 54.98806,50.158354 L 58.61561,49.903244 L 58.61561,64.891154 L 51.65971,64.866794 L 51.60601,59.498904 C 53.807,59.767434 54.71953,59.230534 54.12908,57.297744 L 50.63961,57.351444",
    id: "path2719",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.98785,41.723854 C 53.98785,41.723854 55.08354,41.728334 55.1946,41.058484 L 58.81485,41.058484 L 58.81485,48.980774 L 55.15764,48.980774 C 54.9763,48.872034 55.1946,48.025814 53.80269,48.149144 L 44.66155,48.149144 C 44.5258,48.173674 36.45051,49.322074 38.60078,39.517724 L 42.45161,39.468664 C 42.45161,39.468664 41.89598,42.098804 44.87705,41.723854 L 53.98785,41.723854",
    id: "path2721",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.15806,34.780564 C 35.15806,37.897064 32.59189,40.423614 29.42683,40.423614 C 26.26143,40.423614 23.69575,37.897064 23.69575,34.780564 C 23.69575,31.664064 26.26143,29.137514 29.42683,29.137514 C 32.59189,29.137514 35.15806,31.664064 35.15806,34.780564",
    id: "path2723",
    style: {
      fill: "#c13128",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfj);
export default __webpack_public_path__ + "static/media/IFJ.162522871b4bb76d73812d6e4fc0bc3c.svg";
export { ForwardRef as ReactComponent };